import React from 'react';
import { NSPButton } from '@components/ui/NSPButton';
import styles from './BladeFooter.module.css';

interface BladeFooterProps {
  onClose: () => void;
  onApply: () => void;
  applyLabel: string;
  saving?: boolean;
  disabled?: boolean;
  saveFeedback?: { status: 'success' | 'error'; message: string } | null;
}

const BladeFooter = ({ onClose, onApply, applyLabel, saving = false, disabled = false, saveFeedback }: BladeFooterProps) => (
  <div className={styles.footer}>
    {saveFeedback && (
      <span
        style={{ fontSize: 13, color: saveFeedback.status === 'success' ? '#3a7d44' : '#c0392b' }}
        data-testid="blade-feedback"
        data-type={saveFeedback.status}
      >
        {saveFeedback.status === 'success' ? 'Saved successfully!' : saveFeedback.message}
      </span>
    )}
    <button className={styles.cancelButton} onClick={onClose} disabled={saving} data-testid="blade-cancel-button">
      {saveFeedback?.status === 'success' ? 'Close' : 'Cancel'}
    </button>
    <NSPButton onClick={onApply} disabled={saving || disabled} loading={saving} data-testid="blade-apply-button">
      {applyLabel}
    </NSPButton>
  </div>
);

export default BladeFooter;
